import $ from 'jquery';
import customSelect from 'custom-select';
import parsley from 'parsleyjs';

function init() {
  const elements = [...document.getElementsByClassName('form-select')];
  for (const element of elements) {
    const isInvalid = element.classList.contains('is-invalid');
    const isValid = element.classList.contains('is-valid');

    const createdFields = customSelect(element, {
      openerClass: 'custom-select-opener form-select',
    });

    /**
     * @type {HTMLElement}
     */
    const { opener, container } = createdFields[0];

    if (isInvalid) {
      container.classList.add('is-invalid');
      opener.classList.add('is-invalid');
    }

    if (isValid) {
      container.classList.add('is-valid');
      opener.classList.add('is-valid');
    }
  }

  const transition = document.querySelectorAll('.custom-select-panel');
  for (const element of transition) {
    element.ontransitionstart = () => {
      const selectedOption = element.closest('.custom-select-container').querySelector('.custom-select-opener span');
      if (element.closest('.custom-select-container').querySelector('select').value === '') {
        selectedOption.classList.remove('form-select__selected');
      } else {
        selectedOption.classList.add('form-select__selected');
      }

      element.parentNode.classList.add('custom-select-container--is-open');

    };

    element.ontransitionend = () => {
      if (!element.parentNode.classList.contains('is-open')) {
        element.parentNode.classList.remove('custom-select-container--is-open');

        $('select[data-element-type="SingleSelect"]').each(function () {
          if ($(this).parsley().validate() === true) {
            element.parentNode.querySelector('.custom-select-opener').classList.remove('parsley-error');
            element.parentNode.classList.remove('has-error');
          } else {
            element.parentNode.querySelector('.custom-select-opener').classList.add('parsley-error');
            element.parentNode.classList.add('has-error');

          }
        })
      }
    };
  }
}

export default {
  init,
};
